import React, {ReactNode} from "react";
import Header from "./Header";
import Footer from "./Footer";

function PageLayout (props: {children: ReactNode }) {
  const {children} = props

  return (
    <div className="pageContainer">
      <Header />
      <>
        {children}
      </>
      <Footer />
    </div>
  )
}

export default PageLayout
